import { Prose } from '@nikolovlazar/chakra-ui-prose'
import { Container, Image, SimpleGrid } from '@chakra-ui/react'
import * as React from 'react'

export const ImageAndTextBlock = (props: any) => {
  return (
    <>
      <Container maxWidth='6xl'>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={12}>
          <Image
            mt={{ base: 0, lg: 8 }}
            src={props.image.url}
            alt={props.image.alt}
          />
          <Prose>
            <div dangerouslySetInnerHTML={{ __html: props.text }} />
          </Prose>
        </SimpleGrid>
      </Container>
    </>
  )
}

export default ImageAndTextBlock
